<template>
  <v-card>
    <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="this.headers"
      :items="this.dataValue"
      :search="search"
      :items-per-page="20"
      :sort-by.sync="columnName"
      :sort-desc.sync="isDescending"
      :footer-props="{
        'items-per-page-text': 'Filas por página',
        'items-per-page-options': [20, 30, 50, 100, -1],
      }"
      :custom-filter="dataTableCustomSearch"
    >
      <template v-slot:item.promoter="{ item }">
        <span>{{ getPromoter(item.promoter) }}</span>
      </template>
      <template v-slot:item.qualification.qualification="{ item }">
        <span>
          {{ calcularVEP(item.ratings) }}
          ({{
            Number(calcularVEP(item.ratings)) >= 5 &&
            supplierHasValidDocs(item.id)
              ? "Apta"
              : "No Apta"
          }})
        </span>
      </template>
      <template v-slot:item.justification.nifCardInfo="{ item }">
        <v-icon v-if="!item.justification.nifCardInfo.isDoc"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon
          color="primary"
          @click="openPdfPreview(item.justification.nifCardInfo.file)"
          v-else-if="
            item.justification.nifCardInfo.isDoc &&
            item.justification.nifCardInfo.state === 'Vigente'
          "
          >mdi-checkbox-marked</v-icon
        >
        <span v-else class="red--text">Caducado</span>
      </template>
      <template v-slot:item.justification.tributaryCertificateInfo="{ item }">
        <v-icon v-if="!item.justification.tributaryCertificateInfo.isDoc"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon
          color="primary"
          @click="
            openPdfPreview(item.justification.tributaryCertificateInfo.file)
          "
          v-else-if="
            item.justification.tributaryCertificateInfo.isDoc &&
            checkDocState(item.justification.tributaryCertificateInfo.expire)
          "
          >mdi-checkbox-marked</v-icon
        >
        <span v-else class="red--text">Caducado</span>
      </template>
      <template v-slot:item.justification.ssCertificateInfo="{ item }">
        <v-icon v-if="!item.justification.ssCertificateInfo.isDoc"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon
          color="primary"
          @click="openPdfPreview(item.justification.ssCertificateInfo.file)"
          v-else-if="
            item.justification.ssCertificateInfo.isDoc &&
            checkDocState(item.justification.ssCertificateInfo.expire)
          "
          >mdi-checkbox-marked</v-icon
        >
        <span v-else class="red--text">Caducado</span>
      </template>
      <template v-slot:item.justification.copyCertificateMSInfo="{ item }">
        <v-icon v-if="!item.justification.copyCertificateMSInfo.isDoc"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon
          color="primary"
          @click="openPdfPreview(item.justification.copyCertificateMSInfo.file)"
          v-else-if="
            item.justification.copyCertificateMSInfo.isDoc &&
            checkDocState(item.justification.copyCertificateMSInfo.expire)
          "
          >mdi-checkbox-marked</v-icon
        >
        <span v-else class="red--text">Caducado</span>
      </template>
      <template v-slot:item.embargo="{ item }">
        <v-icon v-if="item.embargo === 'no'"
          >mdi-checkbox-blank-circle-outline</v-icon
        >
        <v-icon color="error" v-else>mdi-checkbox-marked</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          x-small
          color="primary"
          :to="'/cesupplier/' + item.id"
          target="_blank"
        >
          <v-icon small>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          x-small
          color="error"
          @click="deleteItem(item.id)"
          v-if="item && getUserData && item.promoter === getUserData.id"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <PreviewPdf :isDialog="dialog" :url="url" @closeDialog="closePdfPreview" />
  </v-card>
</template>

<script>
import services from "@/services/services";
import Snackbar from "@/components/Snackbar";
import PreviewPdf from "@/components/PreviewPdf.vue";
import fieldValidation from "@/utils/fieldValidation.js";
import { formatVEP } from "@/utils/supplierEvaluation.js";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "SupplierTable",
  props: ["headers", "values"],
  components: {
    Snackbar,
    PreviewPdf,
  },
  data() {
    return {
      search: "",
      textError: null,
      isSnackbar: false,
      dialog: false,
      url: "",
      dataValue: [],
      columnName: "businessName",
      isDescending: false,
    };
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    getPromoter(id) {
      let promoter = this.getObjectById("users", id);
      return promoter ? `${promoter.name} ${promoter.surname}` : "";
    },
    deleteItem(id) {
      this.setActionsLoader(true);
      services
        .deleteData("suppliers", id)
        .then(() => {
          this.setActionsLoader(false);
          this.textError = null;
          this.isSnackbar = true;
        })
        .catch((e) => {
          console.error(e);
          this.setActionsLoader(false);
          this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
          this.isSnackbar = true;
        });
    },
    openPdfPreview(url) {
      this.url = url;
      this.dialog = true;
    },
    closePdfPreview() {
      this.dialog = false;
    },
    checkDocState(date) {
      return fieldValidation.checkState(date);
    },
    supplierHasValidDocs(elem) {
      let areValidDocs = this.getVaildSuppliers.findIndex(
        (supplier) => supplier.id === elem
      );
      return areValidDocs >= 0;
    },
    calcularVEP(ratings) {
      return formatVEP(ratings, this.getContracts);
    },
    buildSupplierRow(item) {
      const vep = this.calcularVEP(item.ratings);
      const apta =
        Number(vep) >= 5 && this.supplierHasValidDocs(item.id)
          ? "Apta"
          : "No Apta";
      return {
        ...item,
        searchFieldsText: `${item.businessName} ${item.nif} ${this.getPromoter(
          item.promoter
        )} ${vep} ${apta}`,
      };
    },
    refreshSupplierRows() {
      this.dataValue = (this.values || []).map((item) =>
        this.buildSupplierRow(item)
      );
    },
  },
  watch: {
    values() {
      this.refreshSupplierRows();
    },
    getContracts() {
      this.refreshSupplierRows();
    },
  },
  computed: {
    ...mapGetters([
      "getObjectById",
      "getCanDelete",
      "getVaildSuppliers",
      "getUserData",
      "getContracts",
    ]),
  },
  created() {
    this.refreshSupplierRows();
  },
};
</script>

<style></style>
